import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-marketing",
  "use": "icon-marketing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-marketing\"><path d=\"M352 320H96v448h256V320z m-96 352h-64V416h64v256zM640 192H384v576h256V192z m-96 480h-64V288h64v384zM928 64H672v704h256V64z m-96 608h-64V160h64v512zM64 832h896v128H64z\" p-id=\"15726\" fill=\"#707070\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/marketing.svg
// module id = mkJ9
// module chunks = 85